export default __webpack_public_path__ + "static/media/Browser.d27fcfea.png";